// extracted by mini-css-extract-plugin
module.exports = {"switch":"Toggle_switch__WRMUh","slider":"Toggle_slider___aBCP","round":"Toggle_round__1J2aI"};